import React from 'react'
import CollectionOfLinkBoxes from './CollectionOfLinkBoxes'

function MyWritingArea() {
    const linkCollectionName = "Writing";
    const linkCollectionDescription = "You can find my writing in the following places:"
    const myWebsites = [{
        title: "You Don't Seem Autistic",
        description: "A blog about autism and my life as an autistic person.",
        url: "http://youdontseemautistic.com/"
    },{
        title: "George Weller's Education Blog",
        description: "My thoughts about learning and teaching.",
        url: "https://georgewellereducationblog.home.blog/"
    },{
        title: "Why You Should Vote Labour",
        description: "A blog I made for the 2019 UK general election. (This was just for that election, I don't have an opinion on how you should vote in general).",
        url: "https://www.whyyoushouldvotelabour.co.uk/"
    }];
    return (
        <div>
            <CollectionOfLinkBoxes linkCollectionName={linkCollectionName} linkCollectionDescription={linkCollectionDescription} links={myWebsites}></CollectionOfLinkBoxes>
        </div>
    )
}

export default MyWritingArea
